<template functional>
  <v-layout column>
    <v-flex xs12>
      <div class="resultContainer">
        <v-layout
          align-center
          column
          fill-height
          justify-center>
          <h1>Unknown Company</h1>
          <p>
            The company specified does not exist. Please contact your inspector
            directly if you arrived at this page from their website.
          </p>
          <p>
            <a href="https://support.homegauge.com/hc/en-us" target="_blank">HomeGauge support</a>.
          </p>
        </v-layout>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import '../styles/vars/theme';
@import '../styles/vars/typography';

h1 {
  color: $theme-color-gray;
  font-family: $typography-font-primary;
  font-size: 36px;
  font-weight: $typography-weight-normal;
  line-height: 1.28;
}

p {
  font-family: $typography-font-primary;
  font-size: 16px;
  font-weight: $typography-weight-semibold;
  font-style: normal;
  font-stretch: normal;
  margin: 5px;
  text-align: center;
}

.resultContainer {
  height: 350px;
}

.logo-container {
  align-items: center;
  display: flex;
  height: 100px;
  justify-content: center;
  margin-left: 20px;
  width: 200px;
}
</style>
